import { Link } from "react-router-dom";
import Tags from "../utils/Tags";

export default function RelatedBlogContainer({ blog }) {
  const { id, image, title, tags, createdAt } = blog;
  return (
    <div className="card">
      <Link to={`/blogs/${id}`}>
        <img
          src={image}
          className="card-image"
          alt="ai"
        />
      </Link>
      <div className="p-4">
        <Link
          to={`/blogs/${id}`}
          className="text-lg post-title lws-RelatedPostTitle"
        >
          {title}
        </Link>
        <Tags
          className="mb-0 tags"
          tags={tags}
        />
        <p>{createdAt}</p>
      </div>
    </div>
  );
}
